<template>
  <v-app>
    <v-fade-transition mode="out-in">
      <router-view></router-view>
    </v-fade-transition>
    <rx-snackbar></rx-snackbar>
    <rx-message-box></rx-message-box>
  </v-app>
</template>

<script>
import RxSnackbar from "@/redworks/components/common/RxSnackbar";
import RxMessageBox from "@/redworks/components/common/RxMessageBox";

export default {
  name: "App",
  components: {
    RxSnackbar,
    RxMessageBox
  },
  data() {
    return {};
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        //화면 이동 시 탭 타이틀 제목도 변경
        document.title = this.$t(to.meta.title) || "한국마사회";
      },
    },
  },
};
</script>
